<template>
  <div class="alarm-page">
    <div class="page-scroll">
      <div class="filter-section">
        <div class="time-range-row" @click="showDatePicker('start')">
          <van-icon name="clock-o" class="range-icon" />
          <span class="range-label">时间</span>
          <span class="range-value">{{ startTime || '开始日期' }}</span>
          <span class="range-sep">~</span>
          <span class="range-value">{{ endTime || '结束日期' }}</span>
        </div>

        <div class="time-actions">
          <van-button type="primary" block class="query-btn" @click="queryAlarms">
            <van-icon name="search" />
            <span>查询</span>
          </van-button>
        </div>
      </div>

      <div class="status-tabs">
        <div class="status-tab" :class="{ active: activeStatus === '0' }" @click="switchStatus('0')">
          <span class="tab-title">待处理</span>
          <span class="tab-count">{{ pendingCount }}</span>
        </div>
        <div class="status-tab" :class="{ active: activeStatus === '1' }" @click="switchStatus('1')">
          <span class="tab-title">已处理</span>
          <span class="tab-count">{{ processedCount }}</span>
        </div>
      </div>

      <alarm-list-panel
        :items="alarmList"
        :status="activeStatus"
        :loading.sync="loading"
        :finished="finished"
        :refreshing.sync="refreshing"
        @load="loadMore"
        @refresh="onRefresh"
        @open-handle="handleAlarm"
        @show-detail="handleView"
      />
    </div>

    <AlarmDetailPopup v-model="dialogVisible" mode="handle" :alarm-data="formData" @submit="submitForm"/>

    <AlarmDetailPopup v-model="viewDialog" mode="detail" :alarm-data="formView"/>

    <van-popup v-model="showDatePickerFlag" position="bottom" round :style="{ height: '52%' }">
      <div class="date-picker">
        <div class="date-picker-header">
          <span class="date-picker-cancel" @click="showDatePickerFlag = false">取消</span>
          <span class="date-picker-title">选择时间范围</span>
          <span class="date-picker-confirm" @click="confirmDateRange">确认</span>
        </div>
        <div class="date-picker-tabs">
          <div class="date-tab" :class="{ active: datePickerTab === 'start' }" @click="switchDateTab('start')">
            开始时间
          </div>
          <div class="date-tab" :class="{ active: datePickerTab === 'end' }" @click="switchDateTab('end')">
            结束时间
          </div>
        </div>
        <van-datetime-picker
          v-if="datePickerReady"
          v-model="currentPickerDate"
          type="date"
          title=""
          :show-toolbar="false"
          class="date-picker-wheel"
        />
      </div>
    </van-popup>

    <tabular :active="1" />
  </div>
</template>

<script>
import Tabular from '@/components/tabbar';
import AlarmListPanel from '@/components/alarm/AlarmListPanel';
import AlarmDetailPopup from '@/components/alarm/AlarmDetailPopup';
import { Dialog, Toast } from 'vant';
import _ from 'lodash';
import { tenantData } from '@/utils/tenantUtils';
import $ from '@/fly';

export default {
  name: 'alarm-alarmInfo',
  components: { Tabular, AlarmListPanel, AlarmDetailPopup },
  data() {
    return {
      currentEquCode: '',
      activeStatus: '0',
      pendingCount: 0,
      processedCount: 0,
      alarmList: [],
      loading: false,
      finished: false,
      refreshing: false,
      pageNum: 1,
      pageSize: 10,
      startTime: '',
      endTime: '',
      showDatePickerFlag: false,
      currentDatePicker: 'start',
      datePickerTab: 'start',
      datePickerReady: false,
      currentPickerDate: new Date(),
      dialogVisible: false,
      viewDialog: false,
      formData: { userName: '', measures: '' },
      formView: {}
    }
  },
  mounted() {
    this.currentEquCode = tenantData.getEquCode() || '';
    this.setDateRange('7');
    this.$nextTick(() => {
      this.initData();
    });
  },
  methods: {
    setDateRange(days) {
      const endDate = new Date();
      const startDate = new Date();
      startDate.setDate(startDate.getDate() - parseInt(days));
      const formatDate = (date) => {
        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, '0');
        const d = String(date.getDate()).padStart(2, '0');
        return `${y}-${m}-${d}`;
      };
      this.startTime = formatDate(startDate);
      this.endTime = formatDate(endDate);
    },
    showDatePicker(type) {
      this.currentDatePicker = type;
      this.datePickerTab = type;
      const savedStr = type === 'start' ? this.startTime : this.endTime;
      if (savedStr) {
        const parts = savedStr.split('-');
        this.currentPickerDate = new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
      } else {
        this.currentPickerDate = new Date();
      }
      this.datePickerReady = false;
      this.showDatePickerFlag = true;
      this.$nextTick(() => {
        this.datePickerReady = true;
      });
    },
    switchDateTab(tab) {
      this.datePickerTab = tab;
      const savedStr = tab === 'start' ? this.startTime : this.endTime;
      if (savedStr) {
        const parts = savedStr.split('-');
        this.currentPickerDate = new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
      } else {
        this.currentPickerDate = new Date();
      }
    },
    confirmDateRange() {
      const value = this.currentPickerDate;
      const y = value.getFullYear();
      const m = String(value.getMonth() + 1).padStart(2, '0');
      const d = String(value.getDate()).padStart(2, '0');
      const formatted = `${y}-${m}-${d}`;

      if (this.datePickerTab === 'start') {
        if (this.endTime && new Date(formatted) > new Date(this.endTime)) {
          Dialog.alert({ title: '提示', message: '开始时间不能大于结束时间' });
          return;
        }
        this.startTime = formatted;
        this.datePickerTab = 'end';
        const endStr = this.endTime;
        if (endStr) {
          const parts = endStr.split('-');
          this.currentPickerDate = new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
        } else {
          this.currentPickerDate = new Date();
        }
      } else {
        if (this.startTime && new Date(formatted) < new Date(this.startTime)) {
          Dialog.alert({ title: '提示', message: '结束时间不能小于开始时间' });
          return;
        }
        this.endTime = formatted;
        this.showDatePickerFlag = false;
      }
    },
    initData() {
      this.queryAlarms();
    },
    queryAlarms() {
      this.pageNum = 1;
      this.finished = false;
      this.alarmList = [];
      this.$nextTick(() => {
        this.loadCounts();
        this.finished = true;
        this.loadAlarms();
      });
    },
    loadCounts() {
      $.get('mobile/alarm/alarmCounts', {
        startTime: this.startTime,
        endTime: this.endTime,
        equCode: this.currentEquCode
      }).then(res => {
        this.pendingCount = res.data.pendingCount || 0;
        this.processedCount = res.data.processedCount || 0;
      })
    },
    loadAlarms(isRefresh) {
      if (!isRefresh) {
        this.loading = true;
      }
      $.get('mobile/alarm/alarmData', {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        status: this.activeStatus,
        startTime: this.startTime,
        endTime: this.endTime,
        equCode: this.currentEquCode
      }).then(res => {
        const data = res.data || [];
        if (this.pageNum === 1) {
          this.alarmList = [...data];
        } else {
          this.alarmList = [...this.alarmList, ...data];
        }
        this.finished = data.length < this.pageSize;
        if (!this.finished) {
          this.pageNum++;
        }
        this.loading = false;
        this.refreshing = false;
      })
    },
    switchStatus(status) {
      if (this.activeStatus === status) return;
      this.activeStatus = status;
      this.pageNum = 1;
      this.finished = false;
      this.alarmList = [];
      this.$nextTick(() => {
        this.finished = true;
        this.loadAlarms();
      });
    },
    loadMore() {
      if (!this.finished && !this.refreshing) {
        this.loadAlarms();
      } else {
        this.loading = false;
      }
    },
    onRefresh() {
      this.loading = false;
      this.pageNum = 1;
      this.finished = true;
      this.alarmList = [];
      this.loadAlarms(true);
      this.loadCounts();
    },
    handleAlarm(item) {
      this.formData = _.cloneDeep(item);
      this.dialogVisible = true;
    },
    handleView(item) {
      this.formView = _.cloneDeep(item);
      this.viewDialog = true;
    },
    submitForm(formData) {
      $.post('mobile/alarm/dealAlarm', formData, { contentType: 'application/json' })
        .then(() => {
          Toast.success('处理完成！');
          this.queryAlarms();
        }).finally(() => {
          this.dialogVisible = false;
        })
    },
  },
}
</script>

<style lang="less" scoped>
/* 页面占满视口，筛选区固定，列表区内部滚动 */
.alarm-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #F5F7FA;
}

.page-scroll {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  padding: 12px;
}

.filter-section {
  flex-shrink: 0;
  background: #fff;
  border-radius: 14px;
  padding: 16px;
  margin-bottom: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.time-range-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 22px 20px;
  background: #F8FAFC;
  border-radius: 12px;
  cursor: pointer;
  min-height: 80px;
  box-sizing: border-box;

  &:active {
    background: #F0F2F5;
  }
}

.range-icon {
  color: #1B75F6;
  font-size: 32px;
  flex-shrink: 0;
}

.range-label {
  font-size: 28px;
  color: #1a365d;
  font-weight: 600;
  flex-shrink: 0;
  min-width: 72px;
}

.range-value {
  flex: 1;
  font-size: 28px;
  color: #303133;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
}

.range-sep {
  font-size: 26px;
  color: #909399;
  flex-shrink: 0;
}

.time-actions {
  padding: 4px 0 0;
}

.query-btn {
  height: 72px;
  border-radius: 36px;
  font-size: 30px;
  font-weight: 600;
  background: linear-gradient(135deg, #1B75F6 0%, #4A90E2 100%);
  border: none;
  box-shadow: 0 4px 16px rgba(27, 117, 246, 0.3);

  .van-icon {
    margin-right: 8px;
  }
}

.date-picker {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #fff;
}

.date-picker-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 32px 16px;
  border-bottom: 1px solid #F0F2F5;
}

.date-picker-cancel {
  font-size: 30px;
  color: #64748B;
  cursor: pointer;
}

.date-picker-title {
  font-size: 32px;
  font-weight: 600;
  color: #1a365d;
}

.date-picker-confirm {
  font-size: 30px;
  color: #1B75F6;
  font-weight: 600;
  cursor: pointer;
}

.date-picker-tabs {
  display: flex;
  padding: 0 32px;
  border-bottom: 1px solid #F0F2F5;
}

.date-tab {
  flex: 1;
  text-align: center;
  padding: 24px 0;
  font-size: 28px;
  color: #64748B;
  position: relative;
  cursor: pointer;
  transition: all 0.2s;

  &.active {
    color: #1B75F6;
    font-weight: 600;

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 48px;
      height: 4px;
      background: linear-gradient(135deg, #1B75F6 0%, #4A90E2 100%);
      border-radius: 2px;
    }
  }
}

.date-picker-wheel {
  flex: 1;

  ::v-deep .van-picker__column {
    flex: 1;
  }

  ::v-deep .van-picker-column__item .van-ellipsis {
    color: #303133;
  }

  ::v-deep .van-picker-column__item--selected .van-ellipsis {
    color: #1B75F6;
    font-weight: 600;
  }
}

.status-tabs {
  display: flex;
  background: #fff;
  border-radius: 14px;
  padding: 6px;
  margin-bottom: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  flex-shrink: 0;
}

.status-tab {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 14px 0;
  font-size: 28px;
  color: #64748B;
  border-radius: 10px;
  transition: all 0.3s;

  &.active {
    background: linear-gradient(135deg, #1B75F6 0%, #4A90E2 100%);
    color: #fff;
    font-weight: 600;
  }

  .tab-count {
    font-size: 24px;
    padding: 2px 12px;
    border-radius: 12px;
    background: #F1F5F9;
    color: #FF4D4F;

    .active & {
      background: rgba(255, 255, 255, 0.25);
      color: #fff;
    }
  }
}

</style>
